import { useEffect, useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

export const FormFloatingBack = ({
    onClick,
    onNext = null,
    showBack = true,
    showNext = false,
    label = 'Volver al paso anterior',
    nextLabel = 'Ir al paso siguiente',
    threshold = 0.5,
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const viewportThreshold = window.innerHeight * threshold;
            setIsVisible(window.scrollY >= viewportThreshold);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, [threshold]);

    if (!isVisible || (!showBack && !showNext)) return null;

    return (
        <div className="LStudio__app_form_floating_navigation" aria-label="Navegación entre pasos">
            {showBack && (
                <button
                    type="button"
                    className="LStudio__app_form_floating_back LStudio__app_form_floating_back--previous"
                    onClick={onClick}
                    aria-label={label}
                    title={label}
                >
                    <FaArrowLeft aria-hidden="true" />
                </button>
            )}

            {showNext && onNext && (
                <button
                    type="button"
                    className="LStudio__app_form_floating_back LStudio__app_form_floating_back--next"
                    onClick={onNext}
                    aria-label={nextLabel}
                    title={nextLabel}
                >
                    <FaArrowRight aria-hidden="true" />
                </button>
            )}
        </div>
    );
};
